import { render } from "./SelectGtin.vue?vue&type=template&id=193e9536"
import script from "./SelectGtin.vue?vue&type=script&lang=js"
export * from "./SelectGtin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\19480-florette\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__